/**
 * 各版本需要隐藏的功能设置
 * 如果当前版本同时属于配置中的多个版本，那么需要将它们的隐藏功能取并集
 * 如：私有化的window server版本，需要PRIVATE_HIDE_FUNC和SERVER_HIDE_FUNC并集
 * JP_ONLY_FUNC 为日本环境专属功能，非日本环境一并隐藏
 */

import { IS_PRIVATE, IS_SERVER } from '@/common/const/env'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'

/** 全部会被隐藏的功能 多级功能用双下划线分割 */
export enum HideFuncEnum {
  /** 登录-微信 */
  login__weChat = 'login__weChat',
  /** 登录-手机 */
  login__mobile = 'login__mobile',
  /** 远程协助 */
  remoteAssist = 'remoteAssist',
  /** 服务-订阅 */
  service__subscribe = 'service__subscribe',
  /** 服务-授权 */
  service__auth = 'service__auth',
  /** 邮件通知 */
  emailNotice = 'emailNotice',
  /** 更新-版本 */
  update__version = 'update__version',
  /** 更新-病毒库 */
  update__cloudLibrary = 'update__cloudLibrary',
  /** 管理员账号-转让 */
  account__transfer = 'account__transfer',
  /** 管理员账号-修改信息 */
  account__modifyInfo = 'account__modifyInfo',
  /** 管理员账号-重置密码 */
  account__resetPassword = 'account__resetPassword',
  /** 管理员账号-停用 */
  account__disable = 'account__disable',
  /** 联系客服 */
  customerService = 'customerService',
  /** 全部macos功能 */
  macos = 'macos',
  /** 依赖ti的功能 */
  threatIntel = 'threatIntel',
  /** 邮件通知 */
  emailNotify = 'emailNotify',
  /** 文件白名单 */
  fileWhitelist = 'fileWhitelist',
  /** 团队级联 */
  teamCascade = 'teamCascade',
  /** 服务器状态 */
  runStatus = 'runStatus',
  /** 位置信息（依赖 Google Maps，仅日本环境显示） */
  locationInfo = 'locationInfo',

  // 系统配置
  system_config = 'system_config',
}

/** 私有版需要隐藏的功能 */
export const PRIVATE_HIDE_FUNC = [
  HideFuncEnum.login__weChat,
  HideFuncEnum.login__mobile,
  HideFuncEnum.service__subscribe,
  // HideFuncEnum.service__auth,
  HideFuncEnum.emailNotice,
  HideFuncEnum.account__transfer,
  HideFuncEnum.macos,
  HideFuncEnum.threatIntel,
  HideFuncEnum.emailNotify,
]

/** WINDOW SERVER版需要隐藏的功能 */
export const SERVER_HIDE_FUNC = [
  // HideFuncEnum.remoteAssist,
  // HideFuncEnum.fileWhitelist,
]

/** SAAS版需要隐藏的功能 */
export const SAAS_HIDE_FUNC = [
  HideFuncEnum.update__version,
  HideFuncEnum.update__cloudLibrary,
  HideFuncEnum.account__modifyInfo,
  HideFuncEnum.account__resetPassword,
  HideFuncEnum.account__disable,
  HideFuncEnum.system_config,
  HideFuncEnum.teamCascade,
  HideFuncEnum.runStatus,
]

/** 日本环境专属功能（仅日本环境显示，非日本环境隐藏） */
export const JP_ONLY_FUNC = [
  HideFuncEnum.locationInfo,
]

export type HideFunc = {
  [key in HideFuncEnum]: boolean
}

/** 当前版需要隐藏的功能 */
const CURRENT_HIDE_FUNC = (() => {
  const hideFunc = []
  if (IS_PRIVATE) {
    hideFunc.push(...PRIVATE_HIDE_FUNC)
  }
  if (!IS_PRIVATE) {
    hideFunc.push(...SAAS_HIDE_FUNC)
  }
  if (IS_SERVER) {
    hideFunc.push(...SERVER_HIDE_FUNC)
  }
  if (!IS_JP_ONLY_BUILD) {
    hideFunc.push(...JP_ONLY_FUNC)
  }
  return [...new Set(hideFunc)]
})()

/**
 * 当前隐藏功能映射
 * 外部统一使用这个常量
 */
export const HIDE_FUNC: HideFunc = (() => {
  const data = {} as HideFunc
  Object.keys(HideFuncEnum).forEach((key) => {
    if (typeof key === 'number') {
      return
    }
    data[key] = !!CURRENT_HIDE_FUNC.includes(key)
  })
  return data
})()
